import { createApp } from 'vue';
import { createPinia } from 'pinia'
import Notifications from '@kyvg/vue3-notification'
import { vue3Debounce } from 'vue-debounce'
import App from './App.vue';
import './index.css';

const app = createApp(App);
const pinia = createPinia()
app.use(pinia)
app.use(Notifications);
app.directive('debounce', vue3Debounce({ lock: true }))
app.mount('#app');

